<status-chip [status]="chipStatus" [title]="status | titlecase" [tooltipText]="statusTooltip" />
